module.exports = __webpack_public_path__ + "static/media/online.9a746994.svg";